import { useContext, useState } from "react";
import classes from "./TermsPage.module.css";

const ArchangelTermsPage = () => {
  const [selectedTab, setSelectedTab] = useState("Global");

  const tabs = ["Global", "US/CA", "Starter Plan"];

  const renderContent = () => {
    switch (selectedTab) {
      case "US/CA":
        return (
          <>
            <p>
              <strong>0.1</strong> Effective Date: 8th June, 2025
            </p>
            <p>
              <strong>0.2</strong> These Terms of Service ("Agreement") govern
              the use of the Archangel Instant Funding Program and its
              associated trading platform ("Platform"), provided by Prime Bridge
              Securities LLC ("PB"), to users participating through M.M
              Advertizing FZCO. ("Archangel"). By accessing the Platform or
              engaging in trading activity, you agree to be legally bound by
              these terms.
            </p>
            <h2>1. Eligibility and Access</h2>
            <p>
              <strong>1.1</strong> The Platform is only available to individuals
              aged 18 years or older.
            </p>
            <p>
              <strong>1.2</strong> Individuals or entities in jurisdictions
              subject to OFAC sanctions are prohibited from accessing the
              Platform.
            </p>
            <p>
              <strong>1.3</strong> Each user is permitted only one active
              evaluation account. Multiple account ownership or account-passing
              is strictly prohibited.
            </p>

            <h2>2. Trading Conditions</h2>
            <p>
              <strong>2.1</strong> The Platform operates as a simulated
              evaluation environment. All accounts utilize virtual funds and do
              not reflect real trading or custody of capital by Archangel or
              Prime Bridge Securities LLC.
            </p>
            <p>
              <strong>2.2</strong> Maximum Drawdown Limit: (Monthly): 10% of the
              starting equity; (IF OTP): 8% drawdown from starting equity.
            </p>
            <p>
              <strong>2.3</strong> Prohibited trading practices include group
              trading, high-frequency trading (HFT), spread arbitrage, market
              manipulation, unauthorized software usage, and account mirroring.
            </p>
            <p>
              <strong>2.4</strong> Maximum Simulated Trade Sizes (Instant
              Funding Only):
            </p>
            <p>
              <strong>2.4 (a)</strong> FX Accounts: 2.5 lots (25K), 5 lots
              (50K), 10 lots (100K).
            </p>
            <p>
              <strong>2.4 (b)</strong> XAUUSD: 0.75 lots (25K), 1.4 lots (50K),
              3.0 lots (100K).
            </p>

            <h2>3. Payouts</h2>
            <p>
              <strong>3.1</strong> Eligibility for payouts commences 14 days
              after the first simulated trade.
            </p>
            <p>
              <strong>3.2</strong> Payout Frequency: Instant Model – every 14
              days; Monthly Model – every 28 days.
            </p>
            <p>
              <strong>3.3</strong> Maximum monthly payout limit: 10% of the
              initial account balance.
            </p>
            <p>
              <strong>3.4</strong> All payouts are discretionary performance
              bonuses from the company's revenue, clearly separated from
              participant fees.
            </p>
            <p>
              <strong>3.5</strong> Monthly reward share schedule:
            </p>
            <ul>
              <li>
                First reward – 60% profit share, minimum 5% payout block (Gold
                unlocks)
              </li>
              <li>Second reward – 60% profit share, minimum 5% payout block</li>
              <li>
                Third reward onwards – 60% profit share, minimum 2.5% payout
                block
              </li>
            </ul>
            <p>
              <strong>3.6</strong> Account balances reset after each payout;
              excess profit beyond 10% is neither payable nor carried forward.
            </p>
            <p>
              <strong>3.7</strong> Payouts may be disbursed via cryptocurrency
              (USDT ERC-20), ACH, or wire transfer. All payout processing is
              managed exclusively by Archangel.
            </p>

            <h2>4. Scaling Provisions</h2>
            <p>
              <strong>4.1</strong> On the One Time Fee (OTP): Applicable to $50K
              and $100K accounts only.
            </p>
            <p>
              <strong>4.2</strong> If your account reaches 10% net profit, you
              may request a scale-up. Once approved, your account will double up
              at each scale level to a maximum of $600,000.
            </p>
            <p>
              <strong>4.3</strong> After scaling to $200K or more:
            </p>
            <ul>
              <li>Withdrawal Frequency: Every 7 days</li>
              <li>Minimum Withdrawal Amount: 2.5%</li>
              <li>Monthly Withdrawal Limit: None</li>
              <li>Profit Share: 80%</li>
              <li>
                Indices (US30, NAS100) and crypto pairs (BTC/USD, ETH/USD,
                XRP/USD) are unlocked
              </li>
              <li>8% fixed drawdown applies</li>
            </ul>
            <p>
              <strong>4.4</strong> On Monthly Model: Eligibility requires 10%
              net profit and no rule violations or resets. Applicable to $50K
              and $100K accounts only.
            </p>
            <p>
              <strong>4.5</strong> Maximum account scaling to $1,000,000 upon
              Risk Desk approval.
            </p>

            <h2>5. Monitoring and Enforcement</h2>
            <p>
              <strong>5.1</strong> All simulated trading activity is subject to
              proprietary risk analytics.
            </p>
            <p>
              <strong>5.2</strong> Accounts violating terms will face immediate
              suspension or termination, with possible payout forfeiture.
            </p>

            <h2>6. Account Resets (Monthly Model Only)</h2>
            <p>
              <strong>6.1</strong> Available only if no prior payouts have been
              withdrawn.
            </p>
            <p>
              <strong>6.2</strong> Fee: 50% of the original subscription price.
            </p>
            <p>
              <strong>6.3</strong> Maximum: One reset per calendar month,
              subject to Risk Desk approval.
            </p>

            <h2>7. Refund Policy</h2>
            <p>
              <strong>7.1</strong> All fees are non-refundable, except under the
              following conditions:
            </p>
            <p>
              <strong>7.2 (a)</strong> No trade placed within 14 days (Instant
              Model only).
            </p>
            <p>
              <strong>7.3 (b)</strong> Platform error, duplicate charge, or at
              Archangel discretion in special circumstances.
            </p>
            <p>
              <strong>7.4</strong> Refunds are not available for accounts
              terminated due to simulated trading violations.
            </p>

            <h2>8. Nature of Evaluation Accounts</h2>
            <p>
              <strong>8.1</strong> Accounts provided on the Platform represent
              evaluation simulations. Participants acknowledge they are
              purchasing access to an evaluation and education service, not a
              real trading account.
            </p>
            <p>
              <strong>8.2</strong> No actual financial instruments are traded,
              and no participant holds any financial position with Archangel or
              Prime Bridge Securities.
            </p>

            <h2>9. Amendments</h2>
            <p>
              <strong>9.1</strong> These Terms may be amended at any time by PB
              and Archangel.
            </p>
            <p>
              <strong>9.2</strong> Users will be notified of changes in advance.
            </p>
            <p>
              <strong>9.3</strong> Continued use of the Platform constitutes
              acceptance of any revised terms.
            </p>

            <h2>10. Transparency and Conflicts of Interest</h2>
            <p>
              <strong>10.1</strong> The company discloses that it may act as a
              simulated counterparty to participant trades within the
              evaluation.
            </p>
            <p>
              <strong>10.2</strong> Simulated trade outcomes are fair,
              transparent, and rule-based, without deliberate interference or
              manipulation.
            </p>

            <h2>11. No Financial Advice</h2>
            <p>
              <strong>11.1</strong> Archangel and Prime Bridge provide
              evaluation services only and do not provide investment, financial,
              legal, or tax advice.
            </p>

            <h2>12. Compliance with Laws</h2>
            <p>
              <strong>12.1</strong> Participants are responsible for compliance
              with all applicable laws and regulations.
            </p>
            <p>
              <strong>12.2</strong> This program is structured as a
              performance-based evaluation for educational and recruitment
              purposes, explicitly not as an investment or financial service.
            </p>

            <h2>13. Data Privacy</h2>
            <p>
              <strong>13.1</strong> Archangel and PB may collect, store, and use
              personal data submitted by users during registration and account
              operation by applicable data protection laws.
            </p>
            <p>
              <strong>13.2</strong> User data will only be used for compliance,
              operational, and support purposes and will not be sold or
              disclosed to third parties except as required by law or necessary
              to provide services.
            </p>
            <p>
              <strong>13.3</strong> By using the Platform, you consent to the
              collection and use of your information as described in this
              clause.
            </p>

            <h2>14. Trading Rules Amendments</h2>
            <p>
              <strong>14.1</strong> Trading rules may be updated or modified at
              any time at the sole discretion of Archangel and PB.
            </p>
            <p>
              <strong>14.2</strong> Notice of any material changes will be
              communicated through the Platform or by email.
            </p>
            <p>
              <strong>14.3</strong> Continued use of the Platform after changes
              take effect constitutes acceptance of the updated terms.
            </p>

            <h2>15. Certifications and Trader Responsibility</h2>
            <p>
              <strong>15.1</strong> Traders certify independent operation and
              full responsibility for trading decisions within the evaluation.
            </p>

            <h2>16. Performance Bonus Cap</h2>
            <p>
              <strong>16.1</strong> Participants may be eligible to receive up
              to 10% of their starting simulated account balance as a monthly
              performance-based bonus. Any profits beyond this cap will not be
              paid out or carried forward. After a payout, the simulated account
              will be reset.
            </p>
            <p>
              <strong>16.2</strong> For Instant Funding (OTF) accounts, trading
              access is paused until the start of the next calendar month after
              payout.
            </p>
            <p>
              <strong>16.3</strong> For Instant Funding (OTP) accounts scaled to
              $200,000 or more, the monthly bonus cap is removed. Bonus payouts
              follow the post-scaling withdrawal guidelines.
            </p>
            <p>
              <strong>16.4</strong> For Monthly Model accounts, trading may
              resume immediately after the reset to starting balance.
            </p>

            <h2>17. Prohibited Strategies and Automation</h2>
            <p>
              <strong>17.1</strong> The following are strictly prohibited:
            </p>
            <ul>
              <li>
                <strong>17.2</strong> Coordinated or group trading across
                accounts to manipulate outcomes
              </li>
              <li>
                <strong>17.3</strong> Use of unauthorized automation tools or
                unapproved trading software
              </li>
              <li>
                <strong>17.4</strong> Copy trading, trade mirroring, or
                replicating trades
              </li>
              <li>
                <strong>17.5</strong> Market distortion or price influence
                tactics
              </li>
              <li>
                <strong>17.6</strong> Account passing or third-party access
              </li>
              <li>
                <strong>17.7</strong> Trades must be manual or with customized
                Archangel Advisor; third-party EAs require written approval
              </li>
            </ul>
            <p>
              <strong>17.8</strong> Violations may lead to disqualification,
              account termination, bonus forfeiture, and no refund eligibility.
            </p>

            <h2>18. Account Ownership Restriction</h2>
            <p>
              <strong>18.1</strong> Only one active evaluation account per
              participant is allowed.
            </p>
            <p>
              <strong>18.2</strong> Violations may result in termination of all
              associated accounts.
            </p>
            <p>
              <strong>18.3</strong> Simulated profits from terminated accounts
              will be forfeited.
            </p>
            <p>
              <strong>18.4</strong> Refunds will not be issued unless an
              exception is granted in writing by the Risk Desk.
            </p>

            <h2>19. Risk Management and Conflicts of Interest</h2>
            <p>
              <strong>19.1</strong> Prime Bridge may simulate acting as the
              counterparty using proprietary risk modeling and algorithms.
            </p>
            <p>
              <strong>19.2</strong> Simulated executions are rule-governed and
              fair, even if economic interests differ.
            </p>

            <h2>20. No Financial Advice</h2>
            <p>
              <strong>20.1</strong> The Platform provides simulated accounts and
              general guidelines for education only. No real capital is
              involved.
            </p>
            <p>
              <strong>20.2</strong> Users are responsible for their own
              decisions and are encouraged to consult professionals for real
              financial decisions.
            </p>

            <h2>21. Risk Disclosure and Acknowledgment</h2>
            <p>
              <strong>21.1</strong> Participation involves significant financial
              risk even in a simulated environment.
            </p>
            <p>
              <strong>21.2</strong> Market conditions can be volatile and
              unpredictable.
            </p>
            <p>
              <strong>21.3</strong> Profitability is not guaranteed; simulations
              are not projections of live performance.
            </p>
            <p>
              <strong>21.4</strong> Users accept full responsibility for
              simulated decisions and outcomes.
            </p>
            <p>
              <strong>21.5</strong> Archangel and Prime Bridge are not liable
              for any losses experienced.
            </p>
            <p>
              <strong>21.6</strong> This program is not registered with the CFTC
              or OSC.
            </p>

            <h2>22. Intellectual Property Rights</h2>
            <p>
              <strong>22.1</strong> All Platform content and tools are the
              property of Archangel, Prime Bridge Securities LLC, or their
              licensors.
            </p>
            <p>
              <strong>22.2</strong> Unauthorized use, reproduction, or
              distribution is prohibited and may lead to legal action.
            </p>

            <h2>23. User Obligations and Conduct</h2>
            <p>
              <strong>23.1</strong> Users agree to:
            </p>
            <ul>
              <li>
                <strong>23.2</strong> Provide accurate and complete information
              </li>
              <li>
                <strong>23.3</strong> Keep account credentials confidential
              </li>
              <li>
                <strong>23.4</strong> Follow Platform rules and policies
              </li>
            </ul>
            <p>
              <strong>23.5</strong> Failure to comply may result in suspension
              or termination.
            </p>

            <h2>24. Dispute Resolution Mechanism</h2>
            <p>
              <strong>24.1</strong> Disputes will be resolved via binding
              arbitration in Saint Vincent and the Grenadines under applicable
              rules.
            </p>
            <p>
              <strong>24.2</strong> Arbitration will be conducted in English,
              and the decision is final.
            </p>

            <h2>25. Termination and Suspension of Accounts</h2>
            <p>
              <strong>25.1</strong> PB and Archangel may suspend or terminate
              access if terms are violated or abuse is detected.
            </p>
            <p>
              <strong>25.2</strong> Termination notifications will be sent via
              email; refund eligibility will follow the Refund Policy and Risk
              Desk review.
            </p>

            <h2>26. Compliance with Applicable Laws</h2>
            <p>
              <strong>26.1</strong> Users must comply with all applicable laws
              in connection with Platform use.
            </p>
            <p>
              <strong>26.2</strong> It is the user's responsibility to ensure
              legality in their jurisdiction.
            </p>

            <h2>27. Force Majeure</h2>
            <p>
              <strong>27.1</strong> Archangel and Prime Bridge are not liable
              for delays or failures caused by events beyond their control,
              including natural disasters, war, terrorism, labor disputes, or
              technical failures.
            </p>

            <h2>28. Severability</h2>
            <p>
              <strong>28.1</strong> If any provision of this Agreement is
              unenforceable, the remaining provisions remain in full effect.
            </p>
          </>
        );
      case "Starter Plan":
        return (
          <>
            <p>Effective Date: October 20th, 2025</p>
            <p>
              These Terms of Use (“Terms”) govern your participation in the <strong>ARCH Starter OTP Plan</strong> (the “Program”). By registering, purchasing
              Starter OTP Plan (the “Program”). By registering, purchasing
              access, or using an ARCH trading account, you agree to abide by
              these Terms in full.
            </p>
            <h2>1. Eligibility</h2>
            <ul>
              <li> You must be at least 18 years old to participate.</li>
              <li>
                You confirm that you are legally permitted to trade financial
                instruments in your country of residence.
              </li>
              <li>Accounts are individual and non-transferable.</li>
            </ul>
            <h2>2. Account Setup</h2>
            <ul>
              <li>
                Each simulated account is issued with a notional balance (e.g.
                $100,000).
              </li>
              <li>
                Program fees are <strong>non-refundable</strong> once paid.
              </li>
              <li>
                Multiple accounts are permitted but must comply with
                diversification rules (see Section 6).
              </li>
            </ul>
            <h2>3. Risk Rules</h2>
            <p>
              A breach of any of the following rules will result in account
              termination. When an account is terminated, a trader will need to
              purchase a new account to begin trading once again:
            </p>
            <strong>3.1 Daily Loss Limit</strong>
            <ul>
              <li>Maximum daily loss: $3,000</li>
              <li>
                Calculation: The daily loss limit is the maximum amount a trader
                is allowed to lose in a day, calculated as a percentage (3%) of
                the initial deposit. Daily losses reset at 00:00 platform time
                (GMT+2).
              </li>
            </ul>
            <strong>3.2 Maximum Trailing Loss</strong>
            <ul>
              <li>
                Maximum trailing loss: 5% of the highest equity achieved since
                account creation
              </li>
              <li>
                After an approved withdrawal, the trailing loss will reset based
                on the account equity after the withdrawn funds are removed from
                the account
              </li>
            </ul>
            <strong>3.3 Daily Profit Cap</strong>
            <ul>
              <li>Maximum realized and unrealized profit per day: $1,000</li>
              <li>
                Calculation: The daily profit cap is the maximum realized and
                unrealized profit a trader is allowed to gain in a day,
                calculated as a percentage of the starting days balance(1%).
                Daily profit caps reset at 00:00 platform time (GMT+2).
              </li>
              <li>
                Exceeding the daily cap:
                <ul>
                  <li>1st offense: Account reset to starting day balance.</li>
                  <li>
                    2nd offense: Account closure with forfeiture of profits and
                    fees.
                  </li>
                </ul>
              </li>

              <li>
                Maximum trailing loss: 5% of the highest equity achieved since
                account creation
              </li>
              <li>
                After an approved withdrawal, the trailing loss will reset based
                on the account equity after the withdrawn funds are removed from
                the account
              </li>
            </ul>
            <strong>3.3 Daily Profit Cap</strong>
            <ul>
              <li>Maximum realized and unrealized profit per day: $1,000</li>
              <li>
                Calculation: The daily profit cap is the maximum realized and
                unrealized profit a trader is allowed to gain in a day,
                calculated as a percentage of the starting days balance(1%).
                Daily profit caps reset at 00:00 platform time (GMT+2).
              </li>
            </ul>
            <strong>3.4 Monthly Profit Cap</strong>
            <ul>
              <li>Maximum realized profit per month: $4,000</li>
            </ul>
            <strong>3.5 Absolute Profit Cap</strong>
            <ul>
              <li>
                The absolute maximum a trader can withdraw from the ARCH Starter
                OTP plan is $6,000 per $100k account. Once a trader reaches this
                amount in total approved withdrawals, they will have graduated
                from the starter program and will be offered a 20% discount on
                any of the standard OTP plans provided by ARCH. Traders who
                reach this milestone will no longer be able to purchase new
                accounts from the ARCH Starter OTP plan.
              </li>
            </ul>
            <h2>4. Payouts</h2>
            <ul>
              <li>
                First payout is available 30 days after placing the first trade.
              </li>
              <li>
                Subsequent payouts are permitted every 28 days, subject to
                compliance with all rules.
              </li>
              <li>
                All payouts are subject to an 70/30 split (70% to trader, 30%
                retained by liquidity provider).
              </li>
              <li>
                Withdrawal requests violating caps or anti-exploit rules will be
                denied.
              </li>
            </ul>
            <h2>5. Offences & Penalties</h2>
            <ul>
              <li>
                Daily Profit Cap Breach: See Section 3.3 for consequences.
              </li>
              <li>
                <strong>Multiple Breaches:</strong> Any combination of two major
                breaches (loss rules or profit cap rules) results in permanent
                account closure
              </li>
              <li>
                <strong>Forfeiture:</strong> In cases of rule violation, all
                profits are forfeited, and fees are non-refundable.
              </li>
            </ul>
            <h2>Multiple Accounts & Strategy Diversification</h2>
            <ul>
              <li>
                If you operate more than one account, you must use{" "}
                <strong>diversified trading strategies.</strong>
              </li>
              <li>
                Prohibited actions include:
                <ul>
                  <li>
                    Trading the same symbol in multiple accounts simultaneously.
                  </li>
                  <li>Cross-hedging between accounts.</li>
                  <li>Mirroring the same trades across accounts</li>
                </ul>
              </li>
              <li>
                <strong>Penalty:</strong> All related accounts closed, no
                withdrawals
              </li>
            </ul>
            <h2>7. Trading Restrictions</h2>
            <ul>
              <li>
                Use of arbitrage, latency exploitation, toxic order flow, or any
                activity deemed abusive by ARCH is prohibited.
              </li>
              <li>Trading activity is monitored for compliance.</li>
              <li>
                Accounts suspected of violating fair use will be terminated.
              </li>
            </ul>
            <h2>8. Program Discretion</h2>
            <ul>
              <li>
                PB and ARCH reserves the right to:
                <ul>
                  Modify, suspend, or terminate accounts found in breach.
                  <li>
                    Adjust program rules to maintain fairness and
                    sustainability.
                  </li>
                  <li>
                    Deny payouts if any suspicious or abusive activity is
                    detected.
                  </li>
                  <li>
                    Deny access to accounts (any fees collected will be
                    refunded)
                  </li>
                </ul>
              </li>
            </ul>
            <h2>9. Limitation of Liability</h2>
            <ul>
              <li>
                PB and ARCH provide access to simulated or risk-managed trading
                accounts; no actual funds are deposited on your behalf.
              </li>
              <li>
                PB and ARCH are not responsible for trading losses, market risk,
                or technical errors beyond their control.
              </li>
              <li>Participation in the Program is at your own risk</li>
            </ul>
            <h2>10. Governing Law</h2>
            <ul>
              <li>
                These Terms are governed by and construed by the laws of Saint
                Vincent and Grenadines
              </li>
              <li>
                Any disputes shall be resolved exclusively in the courts of
                Saint Vincent and Grenadines
              </li>
            </ul>
            <h2>11. Acceptance</h2>
            <p>
              By joining the ARCH Low-Cost OTP Plan, you acknowledge that you
              have read, understood, and agree to abide by these Terms of Use
            </p>
          </>
        );
      default:
        return (
          <>
            <p>
              <strong>0.1</strong> Effective Date: 8th June, 2025
            </p>
            <p>
              <strong>0.2</strong> These Terms of Service ("Agreement") govern
              the use of the Archangel Instant Funding Program and its
              associated trading platform ("Platform"), provided by Prime Bridge
              Securities LLC ("PB"), to users participating through M.M
              Advertizing FZCO. ("Archangel"). By accessing the Platform or
              engaging in trading activity, you agree to be legally bound by
              these terms.
            </p>
            <h2>1. Eligibility and Access</h2>
            <p>
              <strong>1.1</strong> The Platform is only available to individuals
              aged 18 years or older.
            </p>
            <p>
              <strong>1.2</strong> Individuals or entities in jurisdictions
              subject to OFAC sanctions are prohibited from accessing the
              Platform.
            </p>
            <p>
              <strong>1.3</strong> Each user is permitted only one active
              evaluation account. Multiple account ownership or account-passing
              is strictly prohibited.
            </p>

            <h2>2. Trading Conditions</h2>
            <p>
              <strong>2.1</strong> The Platform operates as a simulated
              evaluation environment. All accounts utilize virtual funds and do
              not reflect real trading or custody of capital by M.M Advertizing
              FZCO or Prime Bridge Securities LLC. However, certain tools or
              strategies provided (including but not limited to Archangel's
              proprietary Expert Advisors) may also be used by participants in
              live trading environments independently of the Archangel program.
              Their availability within this evaluation platform does not limit
              or restrict their broader utility or value in real trading
              scenarios.
            </p>
            <p>
              <strong>2.2</strong> Performance criteria: Maximum Drawdown Limit:
              (Monthly) : 10% of the starting equity, (IF OTP) : 8% drawdown
              from starting equity.
            </p>
            <p>
              <strong>2.3</strong> Prohibited trading practices include group
              trading, high-frequency trading (HFT), spread arbitrage, market
              manipulation, unauthorized software usage, and account mirroring.
            </p>
            <p>
              <strong>2.4</strong> Maximum Simulated Trade Sizes (Instant
              Funding Only):
            </p>
            <ol>
              <li>
                FX Accounts: 2.5 lots (25K), 5 lots (50K), 10 lots (100K).
              </li>
              <li>XAUUSD: 0.75 lots (25K), 1.4 lots (50K), 3.0 lots (100K).</li>
            </ol>

            <h2>3. Payouts</h2>
            <p>
              <strong>3.1</strong> Eligibility for payouts commences 14 days
              after the first simulated trade.
            </p>
            <p>
              <strong>3.2</strong> Payout Frequency: Instant Model - every 14
              days; Monthly Model - every 28 days.
            </p>
            <p>
              <strong>3.3</strong> Maximum monthly payout limit: 10% of the
              initial account balance.
            </p>
            <p>
              <strong>3.4</strong> All payouts are discretionary performance
              bonuses from the company's revenue, clearly separated from
              participant fees.
            </p>
            <p>
              <strong>3.5</strong> Monthly reward share schedule
            </p>
            <ul>
              <li>
                First reward - 60% profit share, min 5% payout block (Gold
                unlocks)
              </li>
              <li>Second reward - 60% profit share min 5% payout block</li>
              <li>
                Third reward, onwards - 60% profit share min 2.5% payout block
              </li>
            </ul>
            <p>
              <strong>3.6</strong> Account balances reset after each payout;
              excess profit beyond 10% is neither payable nor carried forward.
            </p>
            <p>
              <strong>3.7</strong> Payouts may be disbursed via cryptocurrency
              (USDT ERC-20), ACH, or wire transfer. All payout processing is
              managed exclusively by Archangel.
            </p>

            <h2>4. Scaling Provisions</h2>
            <p>
              <strong>4.1</strong> On the One time fee OTP: Applicable to $50k
              and $100k accounts only.
            </p>
            <p>
              <strong>4.2</strong> If your account reaches 10% net profit, you
              may request a scale-up. Once approved, your account will double up
              at each scale level to a maximum of $600,000.
            </p>
            <p>
              <strong>4.3</strong> After scaling to $200k or more:
            </p>
            <ul>
              <li>Withdrawal Frequency: Every 7 days</li>
              <li>Minimum Withdrawal Amount: 2.5%</li>
              <li>Monthly Withdrawal Limit: None</li>
              <li>Profit Share: 80%</li>
              <li>
                Indices (US30, NAS100) and crypto pairs (BTC/USD, ETH/USD,
                XRP/USD) are unlocked.
              </li>
              <li>8% fixed drawdown applies.</li>
            </ul>
            <p>
              <strong>4.4</strong> On Monthly Model: Eligibility requires 10%
              net profit and no rule violations or resets. Applicable to $50k
              and $100k accounts only.
            </p>
            <p>
              <strong>4.5</strong> Maximum account scaling to $1,000,000 upon
              Risk Desk approval.
            </p>

            <h2>5. Monitoring and Enforcement</h2>
            <p>
              <strong>5.1</strong> All simulated trading activity is subject to
              proprietary risk analytics.
            </p>
            <p>
              <strong>5.2</strong> Accounts violating terms will face immediate
              suspension or termination, with possible payout forfeiture.
            </p>

            <h2>6. Account Resets (Monthly Model Only)</h2>
            <p>
              <strong>6.1</strong> Available only if no prior payouts have been
              withdrawn.
            </p>
            <p>
              <strong>6.2</strong> Fee: 50% of the original subscription price.
            </p>
            <p>
              <strong>6.3</strong> Maximum: One reset per calendar month,
              subject to Risk Desk approval.
            </p>

            <h2>7. Refund Policy</h2>
            <p>
              <strong>7.1</strong> All fees are non-refundable, except under the
              following conditions:
            </p>
            <p>
              <strong>7.2</strong> (a) No trade placed within 14 days (Instant
              Model only).
            </p>
            <p>
              <strong>7.3</strong> (b) Platform error, duplicate charge, or at
              Archangel's discretion in special circumstances.
            </p>
            <p>
              <strong>7.4</strong> Refunds are not available for accounts
              terminated due to simulated trading violations.
            </p>

            <h2>8. Nature of Evaluation Accounts</h2>
            <p>
              <strong>8.1</strong> Accounts provided on the Platform represent
              evaluation simulations. Participants acknowledge they are
              purchasing access to an evaluation and education service, not a
              real trading account.
            </p>
            <p>
              <strong>8.2</strong> No actual financial instruments are traded,
              and no participant holds any financial position with Archangel or
              Prime Bridge Securities.
            </p>

            <h2>9. Amendments</h2>
            <p>
              <strong>9.1</strong> These Terms may be amended at any time by PB
              and Archangel.
            </p>
            <p>
              <strong>9.2</strong> Users will be notified of changes in advance.
            </p>
            <p>
              <strong>9.3</strong> Continued use of the Platform constitutes
              acceptance of any revised terms.
            </p>

            <h2>10. Transparency and Conflicts of Interest</h2>
            <p>
              <strong>10.1</strong> The company discloses that it may act as a
              simulated counterparty to participant trades within the
              evaluation.
            </p>
            <p>
              <strong>10.2</strong> Simulated trade outcomes are fair,
              transparent, and rule-based, without deliberate interference or
              manipulation.
            </p>

            <h2>11. No Financial Advice</h2>
            <p>
              <strong>11.1</strong> Archangel and Prime Bridge provide
              evaluation services only and do not provide investment, financial,
              legal, or tax advice.
            </p>

            <h2>12. Compliance with Laws</h2>
            <p>
              <strong>12.1</strong> Participants are responsible for compliance
              with all applicable laws and regulations.
            </p>
            <p>
              <strong>12.2</strong> This program is structured as a
              performance-based evaluation for educational and recruitment
              purposes, explicitly not as an investment or financial service.
            </p>

            <h2>13. Data Privacy</h2>
            <p>
              <strong>13.1</strong> Archangel and PB may collect, store, and use
              personal data submitted by users during registration and account
              operation by applicable data protection laws.
            </p>
            <p>
              <strong>13.2</strong> User data will only be used for compliance,
              operational, and support purposes and will not be sold or
              disclosed to third parties except as required by law or necessary
              to provide services.
            </p>
            <p>
              <strong>13.3</strong> By using the Platform, you consent to the
              collection and use of your information as described in this
              clause.
            </p>

            <h2>14. Trading Rules Amendments</h2>
            <p>
              <strong>14.1</strong> Trading rules be updated or modified at any
              time at the sole discretion of Archangel and PB.
            </p>
            <p>
              <strong>14.2</strong> Notice of any material changes will be
              communicated through the Platform or by email.
            </p>
            <p>
              <strong>14.3</strong> Continued use of the Platform after changes
              take effect constitutes acceptance of the updated terms.
            </p>

            <h2>15. Certifications and Trader Responsibility</h2>
            <p>
              <strong>15.1</strong> Traders certify independent operation and
              full responsibility for trading decisions within the evaluation.
            </p>

            <h2>16. Performance Bonus Cap</h2>
            <p>
              <strong>16.1</strong> Participants may be eligible to receive up
              to 10% of their starting simulated account balance as a monthly
              performance-based bonus. If simulated trading results exceed this
              10% threshold, only the first 10% will be considered for a payout.
              Any simulated profits beyond this cap will neither be paid out nor
              carried forward. After a payout, the simulated account will be
              reset to its original starting balance.
            </p>
            <p>
              <strong>16.2</strong> For Instant Funding (OTF) evaluation
              accounts, simulated trading access will be paused until the
              beginning of the next calendar month following the payout.
            </p>
            <p>
              <strong>16.3</strong> For Instant Funding (OTP) evaluation
              accounts that have been scaled to a simulated balance of $200,000
              or more, the monthly performance bonus cap is no longer in effect.
              Participants may request performance-based bonus payouts in
              accordance with the post-scaling simulated withdrawal guidelines.
            </p>
            <p>
              <strong>16.4</strong> For Monthly Model evaluation accounts,
              simulated trading may resume immediately after the account is
              reset to its original starting balance.
            </p>

            <h2>17. Prohibited Strategies and Automation</h2>
            <p>
              <strong>17.1</strong> The following activities are strictly
              prohibited as they compromise the integrity and individual nature
              of the evaluation program:
            </p>
            <p>
              <strong>17.2</strong> Coordinated trading or Group Trading across
              multiple accounts intended to manipulate outcomes.
            </p>
            <p>
              <strong>17.3</strong> Use of unauthorized automation tools or
              trading software that has not been explicitly approved by the Risk
              Desk.
            </p>
            <p>
              <strong>17.4</strong> Engaging in copy trading, trade mirroring,
              or replicating another participant's trades.
            </p>
            <p>
              <strong>17.5</strong> Attempting to manipulate the simulated
              environment through market distortion tactics or price influence
              strategies.
            </p>
            <p>
              <strong>17.6</strong> Use of account passing services, including
              the transfer or sharing of account access with third parties.
            </p>
            <p>
              <strong>17.7</strong> All trades within the Platform must be
              executed either manually or using a personally customized version
              of the Archangel Expert Advisor. The use of third-party Expert
              Advisors (EAs) is permitted only with prior written approval and
              must comply with all platform rules. While these EAs are
              authorized for use within the evaluation framework, they are
              designed for broader trading applications, including deployment in
              real-money environments at the trader's discretion and outside the
              scope of the Archangel simulation.
            </p>
            <p>
              <strong>17.8</strong> Any violation of these conditions may result
              in immediate disqualification from the evaluation program,
              termination of the account, forfeiture of any earned performance
              bonuses, and ineligibility for refunds.
            </p>

            <h2>18. Account Ownership Restriction</h2>
            <p>
              <strong>18.1</strong> Each participant can only operate only one
              active evaluation account within the program. Operating,
              accessing, or managing multiple accounts—either directly or
              indirectly—is strictly prohibited to maintain fairness and
              performance integrity.
            </p>
            <p>
              <strong>18.2</strong> If a participant is found in violation of
              this policy, all associated accounts may be immediately
              terminated.
            </p>
            <p>
              <strong>18.3</strong> Any simulated profits associated with those
              accounts may be forfeited.
            </p>
            <p>
              <strong>18.4</strong> No refunds will be issued for accounts
              terminated under this policy unless an exception is granted in
              writing by the Risk Desk upon formal review.
            </p>

            <h2>19. Risk Management and Conflicts of Interest</h2>
            <p>
              <strong>19.1</strong> Prime Bridge Securities and its affiliated
              partners may simulate acting as the counterparty to your trades
              within the evaluation environment. This is done solely for
              internal risk modeling and is facilitated through proprietary
              tools, including simulated hedging algorithms.
            </p>
            <p>
              <strong>19.2</strong> This simulation-based structure may result
              in economic interests that differ from those of individual
              participants. However, all simulated trade execution is designed
              to be fair, transparent, and governed strictly by predefined rules
              without intentional interference in user outcomes.
            </p>

            <h2>20. No Financial Advice</h2>
            <p>
              <strong>20.1</strong> Archangel and Prime Bridge Securities LLC
              provide access to simulated evaluation accounts and general
              trading guidelines solely for educational and performance
              assessment purposes. While trading activity on the Platform does
              not involve real capital, certain tools made available to
              participants—such as proprietary Expert Advisors (EAs) may also be
              suitable for use in live trading environments. The Platform does
              not offer investment, financial, legal, or tax advice.
            </p>
            <p>
              <strong>20.2</strong> All decisions related to simulated trading
              activities are made at the sole discretion and risk of the
              participant. Users are encouraged to consult with licensed
              professionals regarding any financial decisions outside the scope
              of this simulation.
            </p>

            <h2>21. Risk Disclosure and Acknowledgment</h2>
            <p>
              <strong>21.1</strong> Participating in trading simulations
              involves significant financial risk, particularly when reflecting
              real market behavior. By using the Platform, you acknowledge and
              accept the inherent risks associated with trading-related
              activities, even in a simulated environment.
            </p>
            <p>
              <strong>21.2</strong> Market conditions—whether simulated or
              real—can be volatile, with rapid and unpredictable price
              fluctuations.
            </p>
            <p>
              <strong>21.3</strong> There is no guarantee of profitability.
              While simulated performance may offer insights into strategy
              behavior, it should not be considered a direct projection of
              future performance in live markets, where risk, liquidity, and
              execution variables may differ significantly.
            </p>
            <p>
              <strong>21.4</strong> You accept full responsibility for all
              simulated trading decisions and any corresponding outcomes within
              your evaluation account.
            </p>
            <p>
              <strong>21.5</strong> You agree to use the Platform entirely at
              your own risk and acknowledge that Archangel and Prime Bridge
              Securities LLC bear no responsibility or liability for any
              simulated losses or outcomes experienced during your
              participation.
            </p>
            <p>
              <strong>21.6</strong> This program is not registered with or
              regulated by the Commodity Futures Trading Commission (CFTC) or
              the Ontario Securities Commission (OSC), as it does not involve
              real financial trading or custody of client funds.
            </p>

            <h2>22. Intellectual Property Rights</h2>
            <p>
              <strong>22.1</strong> All content, trademarks, services, and
              proprietary technology on the Platform are the property of
              Archangel, Prime Bridge Securities LLC, or their licensors.
            </p>
            <p>
              <strong>22.2</strong> Unauthorized use, reproduction, or
              distribution of any material from the Platform is strictly
              prohibited and may result in legal action.
            </p>

            <h2>23. User Obligations and Conduct</h2>
            <p>
              <strong>23.1</strong> You agree to:
            </p>
            <p>
              <strong>23.2</strong> Provide accurate and complete information
              during registration and account maintenance.
            </p>
            <p>
              <strong>23.3</strong> Maintain the confidentiality of your account
              credentials and do not share them with others.
            </p>
            <p>
              <strong>23.4</strong> Comply with all Platform rules and policies,
              including trading guidelines and prohibited activities.
            </p>
            <p>
              <strong>23.5</strong> Failure to adhere to these obligations may
              result in account suspension or termination.
            </p>

            <h2>24. Dispute Resolution Mechanism</h2>
            <p>
              <strong>24.1</strong> Any disputes arising from or relating to
              this Agreement shall be resolved through binding arbitration in
              Saint Vincent and the Grenadines, by the rules of the selected
              arbitration institution.
            </p>
            <p>
              <strong>24.2</strong> The arbitration shall be conducted in
              English, and the decision rendered shall be final and binding on
              both parties.
            </p>

            <h2>25. Termination and Suspension of Accounts</h2>
            <p>
              <strong>25.1</strong> Prime Bridge Securities LLC (PB) and
              Archangel reserve the right to suspend or permanently terminate
              your access to the Platform if you are found to have violated any
              provision of these Terms of Service or engaged in conduct that is
              deceptive, abusive, or harmful to the integrity of the evaluation
              program, the Platform, or other participants.
            </p>
            <p>
              <strong>25.2</strong> In the event of termination, you will be
              notified via the email associated with your account. Any remaining
              fee eligibility or refund consideration will be addressed strictly
              in accordance with the applicable Refund Policy and subject to
              final review by the Risk Desk.
            </p>

            <h2>26. Compliance with Applicable Laws</h2>
            <p>
              <strong>26.1</strong> You agree to comply with all applicable
              international, national, state, and local laws and regulations in
              connection with your use of the Platform.
            </p>
            <p>
              <strong>26.2</strong> It is your responsibility to ensure that
              your trading activities are legal in your jurisdiction.
            </p>

            <h2>27. Force Majeure</h2>
            <p>
              <strong>27.1</strong> Archangel and Prime Bridge Securities LLC
              shall not be held liable for any failure or delay in performance
              due to events beyond their reasonable control, including but not
              limited to natural disasters, acts of war, terrorism, labor
              disputes, or technical failures.
            </p>

            <h2>28. Severability</h2>
            <p>
              <strong>28.1</strong> If any provision of this Agreement is found
              to be unenforceable or invalid, the remaining provisions shall
              remain in full force
            </p>
          </>
        );
    }
  };

  return (
    <div className={`${classes.wrapper}`}>
      <h1 className="mt-5">Terms of Service</h1>
      <div className={classes.tabsContainer}>
        {tabs.map((tab, i) => (
          <div
            key={tab}
            className={`${classes.tab} ${
              selectedTab === tab ? classes.active : ""
            }`}
            onClick={() => setSelectedTab(tab)}
          >
            {i + 1 + ". " + tab}
            {selectedTab === tab && <div className={classes.underline} />}
          </div>
        ))}
      </div>
      <div className={classes.termsContent}>{renderContent()}</div>
    </div>
  );
};

export default ArchangelTermsPage;
